module.exports = __webpack_public_path__ + "static/media/10b.602e5a1d.jpeg";